import React from 'react';

import { formatDate, formatMoney } from '@betterment/js-runtime';
import { Box, Icon, Text } from '@betterment/samba-react';
import { Flex, HR, Tooltip } from '@betterment/style-closet-react';

import { IraContributionMatchGrants } from './data';

type Props = {
  iraContributionMatchGrants: IraContributionMatchGrants;
};
const IraMatchSummaries: React.FC<Props> = ({ iraContributionMatchGrants }) => {
  return (
    <>
      {iraContributionMatchGrants?.map(iraContributionMatchGrant => {
        return (
          <Box as="div" key={iraContributionMatchGrant.id}>
            <Flex as="span" justifyContent="space-between" alignItems="center">
              <Flex as="span">
                <Text>Betterment match</Text>
                <Tooltip
                  label={`Your IRA match is based on your net ${
                    iraContributionMatchGrant.grantedEntitiesDescription
                  } contributions between ${formatDate(
                    iraContributionMatchGrant.contributionWindow.start
                  )} - ${formatDate(
                    iraContributionMatchGrant.contributionWindow.end
                  )}. Your match will be paid on or around ${formatDate(
                    iraContributionMatchGrant.projectedPaymentDate
                  )}.`}
                >
                  <Icon name="InfoCircle" size="small" color="icon.weak" />
                </Tooltip>
              </Flex>
              <Flex flexDirection="column" as="span">
                <Text
                  css={{
                    textAlign: 'right',
                  }}
                >
                  {formatMoney(iraContributionMatchGrant.earnedMatchAmount)}
                </Text>
              </Flex>
            </Flex>
            <HR my="6" key={`line-break-${iraContributionMatchGrant.id}`} />
          </Box>
        );
      })}
    </>
  );
};

export default IraMatchSummaries;
